export default __webpack_public_path__ + "static/media/Gymnastik.9e7064e5.jpg";